import { useIntl } from 'react-intl';
import { showNotification } from '../components/molecules/Notifications';
import { Basket } from './checkoutState';

const getBasketItemsSignature = (basket: Basket) =>
  JSON.stringify(basket.packages.flatMap(pkg => pkg.items).map(({ variantId, quantity }) => ({ variantId, quantity })));

const useBasketNotifications = () => {
  const { formatMessage } = useIntl();

  const triggerBasketUpdateNotification = (nextBasket: Basket, prevBasket?: Basket) => {
    if (prevBasket && getBasketItemsSignature(nextBasket) !== getBasketItemsSignature(prevBasket)) {
      const isPromotionRemoved = prevBasket.discount.promotion > 0 && nextBasket.discount.promotion === 0;
      showNotification({
        level: 'info',
        text: formatMessage({
          id: isPromotionRemoved ? 'payment.promotion.notifications.notValid' : 'basket.notifications.basketUpdated'
        }),
        autoClose: true
      });
    }
  };

  const triggerBasketEmptyNotification = () =>
    showNotification({
      level: 'error',
      text: formatMessage({ id: 'basket.notifications.basketEmpty' }),
      autoClose: true
    });

  return { triggerBasketUpdateNotification, triggerBasketEmptyNotification };
};

export default useBasketNotifications;
